// extracted by mini-css-extract-plugin
module.exports = {"newsListWrap":"style_newsListWrap__ZM_Nb","modalClose":"style_modalClose__dJQjr","pagination":"style_pagination__WV_we"};